import {KilnInfo, kmsQueries} from '@domain/kiln-monitoring'
import {Loader} from '@hconnect/uikit/src/lib2'
import {useQuery} from '@tanstack/react-query'
import React, {useContext, createContext, useMemo} from 'react'

interface IKilnContext {
  kilnId: string
  plantKilns: KilnInfo[]
  kilnInfo: KilnInfo
  plantUpmId: string
}

export const KilnContext = createContext<IKilnContext>(null as unknown as IKilnContext)

export type KilnProviderProps = {
  children: React.ReactNode
  kilnId: string
  plantUpmId: string
}

export const KilnProvider = ({children, kilnId, plantUpmId}: KilnProviderProps) => {
  const {data: plantKilns, isPending} = useQuery(kmsQueries.kilnInfo(plantUpmId))

  const kilnInfo = useMemo(
    () => plantKilns?.find((kiln) => kiln.id === kilnId),
    [kilnId, plantKilns]
  )

  if (isPending) return <Loader color="grey" height="30vh" />

  // We cannot proceed without this data so better crash the app early
  if (!plantKilns) throw new Error('No kilns defined in asset config.')
  if (!kilnInfo) throw new Error(`Kiln ${kilnId} not found in asset config.`)

  return (
    <KilnContext.Provider
      value={{
        kilnId,
        kilnInfo,
        plantKilns,
        plantUpmId
      }}
    >
      {children}
    </KilnContext.Provider>
  )
}

export const useKiln = () => useContext(KilnContext)
